/*
 * @Description: 客户相关接口
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @Date: 2023-06-12 14:42:19
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 * @LastEditTime: 2023-08-02 14:46:03
 */
import { BaseService } from './base-service';
class ClientService extends BaseService {
  /**
   * @description: 获取数据列表
   * @param {*} data
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  getCustomerList(data) {
    return this.request({
      method: 'post',
      url: `/customer/list`,
      data
    });
  }

  /**
   * @description:客户详情
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  getCustomer(data) {
    return this.request({
      method: 'get',
      url: `/customer/get`,
      params: data
    });
  }
  /**
   * @description: 线索转化记录
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  customerClueList(data) {
    return this.request({
      method: 'get',
      url: `/customer/clue/list`,
      params: data
    });
  }
  /**
   * @description: 查询客户天眼查信息
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  customerQccSearch(data) {
    return this.request({
      method: 'get',
      url: `/customer/qcc/search`,
      params: data
    });
  }
  /**
   * @description: 绑定工商信息
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  qccBind(data) {
    return this.request({
      method: 'get',
      url: `/customer/qcc/bind`,
      params: data
    });
  }
  /**
   * @description: 查询绑定的工商信息
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  qccInfo(data) {
    return this.request({
      method: 'get',
      url: `/customer/qcc/info`,
      params: data
    });
  }
  /**
   * @description: 查询协作人
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  getCollaborator(data) {
    return this.request({
      method: 'get',
      url: `/collaborator/list`,
      params: data
    });
  }
  /**
   * @description: 添加协作人
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  addCollaborator(data) {
    return this.request({
      method: 'post',
      url: `/collaborator/add`,
      data
    });
  }
  /**
   * @description: 修改协作人
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  updateCollaborator(data) {
    return this.request({
      method: 'post',
      url: `/collaborator/update`,
      data
    });
  }

  /**
   * @description: 协作人--创建群组
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  creatMember(data) {
    return this.request({
      method: 'post',
      url: `/member/creat`,
      data
    });
  }
  /**
   * @description:创建群组--协作人列表
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  getMemberList(data) {
    return this.request({
      method: 'get',
      url: `/member/list`,
      params: data
    });
  }
  /**
   * @description: 协作人--群组信息
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  getMemberInfo(data) {
    return this.request({
      method: 'post',
      url: `/member/getMemberInfo`,
      data
    });
  }

  /**
   * @description:开票列表
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  getInvoice(data) {
    return this.request({
      method: 'get',
      url: `/customer/invoice/getByCustomId`,
      params: data
    });
  }
  /**
   * @description:开票列表--获取抬头类型
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  getInvoiceType(data) {
    return this.request({
      method: 'get',
      url: `/customer/invoice/type`,
      params: data
    });
  }
  /**
   * @description:开票列表--保存开票信息
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  saveInvoice(data) {
    return this.request({
      method: 'post',
      url: `/customer/invoice/save`,
      data
    });
  }

  /**
   * @description:开票列表--删除开票信息
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  delInvoice(data) {
    return this.request({
      method: 'get',
      url: `/customer/invoice/del`,
      params: data
    });
  }

  /**
   * @description:开票列表--设为默认开票信息
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  setDefaultInvoice(data) {
    return this.request({
      method: 'get',
      url: `/customer/invoice/updateDefault`,
      params: data
    });
  }
  /**
   * @description:开票列表--获取地址信息类型
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  getAddressInfoType(data) {
    return this.request({
      method: 'get',
      url: `/customer/addressInfo/type`,
      params: data
    });
  }
  /**
   * @description:地址列表--更新默认
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  updateAddress(data) {
    return this.request({
      method: 'get',
      url: `/customer/addressInfo/updateDefault`,
      params: data
    });
  }
  /**
   * @description:地址信息列表
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  getAddressList(data) {
    return this.request({
      method: 'get',
      url: `/customer/addressInfo/getByCustomId`,
      params: data
    });
  }
  /**
   * @description:地址信息列表--保存地址信息
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  saveAddress(data) {
    return this.request({
      method: 'post',
      url: `/customer/addressInfo/save`,
      data
    });
  }

  /**
   * @description:地址信息列表--删除地址
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  delAddress(data) {
    return this.request({
      method: 'get',
      url: `/customer/addressInfo/del`,
      params: data
    });
  }
  /**
   *  客户作废--作废前校验 是否允许作废
   *
   * @author CaoJianBo
   * @param  {Object} params
   * @param
   * @returns
   * @memberof clientService
   */
  customerCheck(params) {
    return this.request({
      method: 'get',
      url: `/customer/check`,
      params
    });
  }
  /**
   *  客户作废--作废
   *
   * @author CaoJianBo
   * @param  {Object} params
   * @param
   * @returns
   * @memberof clientService
   */
  deleteCustomer(params) {
    return this.request({
      method: 'get',
      url: `/customer/delete`,
      params
    });
  }
  /**
   * @description: 客户名称字段唯一性检查
   * @param {*} data
   * @return {*}
   * @author: 纪楠楠 jinannan@qfei.cn
   */
  customerCheckFieldRepeat(data) {
    return this.request({
      method: 'post',
      url: `/customer/checkFieldRepeat`,
      data
    });
  }
}

export const clientService = new ClientService();
